module.exports = __webpack_public_path__ + "static/media/icon-support-3.d1b40e0c.svg";